import * as React from 'react';
import { IFullPaginationOptions } from './pagination';

export interface IPagingArrowsProps {
    paging: IFullPaginationOptions;
    isLeftArrows: boolean;
    onPageSelect(page: number): void;
}

/// <summary>
/// Renders left or right page arrow content
/// </summary>
/// <returns>Content text</returns>
export class PagingArrows extends React.Component<IPagingArrowsProps, any> {
    render() {
        if (!this.props.paging.totalItems || this.props.paging.totalItems === 0) return null;

        const numberOfPages = this.props.paging.totalPages;

        if (this.props.isLeftArrows) {
            const isDisabled = this.props.paging.pageNumber === 1;
            return (
                <li className="adage-search-pagination-arrows adage-search-pagination-arrows-left">
                    {isDisabled
                        ?
                        <>
                          
                            <button disabled={true} className="un-button adage-search-pagination-link-prev">
                                <span className="adage-search-pagination-icon adage-search-pagination-icon-first"></span>
                            </button>
                            <button disabled={true} className="un-button adage-search-pagination-link-prev">
                                <span className="adage-search-pagination-icon adage-search-pagination-icon-prev"></span>
                            </button>
                        </>
                        :
                        <>
                         
                            <a href="#" className="adage-search-pagination-link-next" onClick={() => this.props.onPageSelect(1)} >
                                <span className="adage-search-pagination-icon adage-search-pagination-icon-first"></span>
                            </a>
                            <a href="#" className="adage-search-pagination-link-next" onClick={() => this.props.onPageSelect(this.props.paging.pageNumber - 1)}>
                                <span className="adage-search-pagination-icon adage-search-pagination-icon-prev"></span>
                            </a>
                        </>
                    }
                </li>
            );
        }
        else {
            const isDisabled = this.props.paging.pageNumber === numberOfPages;
            return (
                <li className="adage-search-pagination-arrows adage-search-pagination-arrows-right">
                    {isDisabled
                        ?
                        <>
                            <button disabled={true} className="un-button adage-search-pagination-link-next">
                                <span className="adage-search-pagination-icon adage-search-pagination-icon-next"></span>
                            </button>
                            <button disabled={true} className="un-button adage-search-pagination-link-next">
                                <span className="adage-search-pagination-icon adage-search-pagination-icon-last"></span>
                            </button>
                        </>
                        :
                        <>
                            <a href="#" className="adage-search-pagination-link-next" onClick={() => this.props.onPageSelect(this.props.paging.pageNumber + 1)}>
                                <span className="adage-search-pagination-icon adage-search-pagination-icon-next"></span>
                            </a>
                            <a href="#" className="adage-search-pagination-link-next" onClick={() => this.props.onPageSelect(this.props.paging.totalPages)}>
                                <span className="adage-search-pagination-icon adage-search-pagination-icon-last"></span>
                            </a>
                        </>
                    }
                </li>
            );
        }
    }
}